(() => {
  if (window.__coinyWelcomeV4) return;
  window.__coinyWelcomeV4 = true;
  const controllers = new WeakMap();

  function initialize(root) {
    if (!root || controllers.has(root)) return controllers.get(root);
    const home = root.querySelector('[data-cm-welcome-home]');
    const panel = root.querySelector('[data-cm-welcome-panel]');
    const dialog = root.querySelector('[data-cm-welcome-dialog]');
    const content = root.querySelector('[data-cm-welcome-dialog-content]');
    if (!home || !panel || !dialog || !content) return null;
    let opener = null;
    let priorOverflow = null;

    function restore() {
      if (panel.parentElement !== home) home.append(panel);
      home.classList.remove('is-in-dialog');
      if (priorOverflow !== null) document.body.style.overflow = priorOverflow;
      priorOverflow = null;
      if (opener?.isConnected) opener.focus({ preventScroll: true });
      opener = null;
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    function open(trigger) {
      const tags = panel.querySelector('[data-cm-welcome-tags]');
      const plannerNote = panel.querySelector('[data-cm-planner-note]');
      const plannerInterest = trigger.hasAttribute('data-cm-welcome-planner');
      if (tags) tags.value = plannerInterest ? 'newsletter,coiny-welcome,coiny-planner-interest' : 'newsletter,coiny-welcome';
      if (plannerNote) plannerNote.hidden = !plannerInterest;
      if (typeof dialog.showModal !== 'function') return false;
      if (dialog.open) return true;
      opener = trigger;
      content.append(panel);
      home.classList.add('is-in-dialog');
      priorOverflow = document.body.style.overflow;
      try {
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      } catch (_) {
        restore();
        return false;
      }
      const initialFocus = panel.querySelector('[data-cm-welcome-success], [data-cm-welcome-error], input[type="email"]');
      initialFocus?.focus({ preventScroll: true });
      return true;
    }

    dialog.addEventListener('close', restore);
    dialog.querySelector('[data-cm-welcome-close]')?.addEventListener('click', close);
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    // Native <dialog> handles the focus boundary and Escape. Form submission
    // stays native; no JavaScript success state or email claim is created.
    const serverStatus = panel.querySelector('[data-cm-welcome-error], [data-cm-welcome-success]');
    if (serverStatus) serverStatus.focus();
    const controller = { open, close };
    controllers.set(root, controller);
    return controller;
  }

  function enhanceTriggers() {
    const root = document.querySelector('[data-cm-welcome]');
    const dialog = root?.querySelector('[data-cm-welcome-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    document.querySelectorAll('[data-cm-welcome-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
    });
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target.closest('[data-cm-welcome-trigger]');
    if (!trigger) return;
    const root = document.querySelector('[data-cm-welcome]');
    const controller = initialize(root);
    if (controller?.open(trigger)) event.preventDefault();
  });
  document.querySelectorAll('[data-cm-welcome]').forEach(initialize);
  enhanceTriggers();
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-cm-welcome]').forEach(initialize);
    enhanceTriggers();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-cm-welcome]').forEach((root) => controllers.get(root)?.close());
  });
})();
